import useAuthGlobal from "src/context/useAuthGlobal";

export const PERMISSIONS = {
  VIEW_USER_ALL: "View:User:All",
  CREATE_USER_ALL: "Create:User:All",
  UPDATE_USER_ALL: "Update:User:All",
  DELETE_USER_ALL: "Delete:User:All",
  VIEW_SALES_ALL: "View:Sales",
  CREATE_SALES_ALL: "Create:Sales:All",
  UPDATE_SALES_ALL: "Update:Sales:All",
  DELETE_SALES_ALL: "Delete:Sales:All",
  RESETPASSWORD_USER_ALL: "ResetPassword:User:All",
  RESETPASSWORD_SALES: "ResetPassword:Sales",
  VIEW_ROLE: "View:Role",
  CREATE_ROLE: "Create:Role",
  UPDATE_ROLE: "Update:Role",
  DELETE_ROLE: "Delete:Role",
  VIEW_WAREHOUSE_ALL: "View:Warehouse:All",
  CREATE_WAREHOUSE_ALL: "Create:Warehouse:All",
  CREATE_WAREHOUSE_OWN: "Create:Warehouse:Own",
  UPDATE_WAREHOUSE_ALL: "Update:Warehouse:All",
  UPDATE_WAREHOUSE_OWN: "Update:Warehouse:Own",
  DELETE_WAREHOUSE_ALL: "Delete:Warehouse:All",
  DELETE_WAREHOUSE_OWN: "Delete:Warehouse:Own",
  VIEW_SHIPPINGPROVIDER_ALL: "View:ShippingProvider:All",
  CREATE_SHIPPINGPROVIDER: "Create:ShippingProvider",
  UPDATE_SHIPPINGPROVIDER: "Update:ShippingProvider",
  DELETE_SHIPPINGPROVIDER: "Delete:ShippingProvider",
  VIEW_MANUFACTURER_ALL: "View:Manufacturer:All",
  CREATE_MANUFACTURER: "Create:Manufacturer",
  UPDATE_MANUFACTURER: "Update:Manufacturer",
  DELETE_MANUFACTURER: "Delete:Manufacturer",
  VIEW_BRAND: "View:Brand",
  CREATE_BRAND: "Create:Brand",
  UPDATE_BRAND: "Update:Brand",
  DELETE_BRAND: "Delete:Brand",
  VIEW_PRODUCTGROUP: "View:ProductGroup",
  UPDATE_PRODUCTGROUP: "Update:ProductGroup",
  VIEW_PRODUCT: "View:Product",
  CREATE_PRODUCT: "Create:Product",
  UPDATE_PRODUCT: "Update:Product",
  DELETE_PRODUCT: "Delete:Product",
  VIEW_BATCH_ALL: "View:Batch:All",
  CREATE_BATCH_ALL: "Create:Batch:All",
  UPDATE_BATCH_ALL: "Update:Batch:All",
  DELETE_BATCH_ALL: "Delete:Batch:All",
  SCANITEM_BATCH_ALL: "ScanItem:Batch:All",
  VIEW_INVENTORY_ALL: "View:Inventory:All",
  UPDATE_INVENTORY_ALL: "Update:Inventory:All",
  VIEW_CUSTOMER: "View:Customer",
  CREATE_CUSTOMER: "Create:Customer",
  UPDATE_CUSTOMER: "Update:Customer",
  DELETE_CUSTOMER: "Delete:Customer",
  CUSTOM_CUSTOMER: "Custom:Customer",
  VIEW_ORDER_ALL: "View:Order:All",
  CREATE_ORDER_ALL: "Create:Order:All",
  UPDATE_ORDER_ALL: "Update:Order:All",
  DELETE_ORDER_ALL: "Delete:Order:All",
  CHANGESTATUS_ORDER_ALL: "ChangeStatus:Order:All",
  PREPARE_ORDER_ALL: "Prepare:Order:All",
  PROCESSRETURNORDER_ORDER_ALL: "ProcessReturnOrder:Order:All",
  VIEW_WAREHOUSETRANSFEREXPORT_ALL: "View:WarehouseTransferExport:All",
  CREATE_WAREHOUSETRANSFEREXPORT_ALL: "Create:WarehouseTransferExport:All",
  UPDATE_WAREHOUSETRANSFEREXPORT_ALL: "Update:WarehouseTransferExport:All",
  PREPARE_WAREHOUSETRANSFEREXPORT_ALL: "Prepare:WarehouseTransferExport:All",
  DELETE_WAREHOUSETRANSFEREXPORT_ALL: "Delete:WarehouseTransferExport:All",
  REVIEW_WAREHOUSETRANSFEREXPORT_ALL: "Review:WarehouseTransferExport:All",
  CHANGESTATUS_WAREHOUSETRANSFEREXPORT_ALL: "ChangeStatus:WarehouseTransferExport:All",
  VIEW_WAREHOUSETRANSFERIMPORT_ALL: "View:WarehouseTransferImport:All",
  CREATE_WAREHOUSETRANSFERIMPORT_ALL: "Create:WarehouseTransferImport:All",
  UPDATE_WAREHOUSETRANSFERIMPORT_ALL: "Update:WarehouseTransferImport:All",
  PREPARE_WAREHOUSETRANSFERIMPORT_ALL: "Prepare:WarehouseTransferImport:All",
  DELETE_WAREHOUSETRANSFERIMPORT_ALL: "Delete:WarehouseTransferImport:All",
  CHANGESTATUS_WAREHOUSETRANSFERIMPORT_ALL: "ChangeStatus:WarehouseTransferImport:All",
  VIEW_INVENTORYNOTE_ALL: "View:InventoryNote:All",
  CREATE_INVENTORYNOTE_ALL: "Create:InventoryNote:All",
  VIEW_PROVIDER: "View:Provider",
  CREATE_PROVIDER: "Create:Provider",
  UPDATE_PROVIDER: "Update:Provider",
  DELETE_PROVIDER: "Delete:Provider",
  VIEW_BANKINFO: "View:BankInfo",
  CREATE_BANKINFO: "Create:BankInfo",
  UPDATE_BANKINFO: "Update:BankInfo",
  DELETE_BANKINFO: "Delete:BankInfo",
  VIEW_SYSTEM_ALL: "View:System:All",
  VIEW_USER_OWN: "View:User:Own",
  CREATE_USER_OWN: "Create:User:Own",
  UPDATE_USER_OWN: "Update:User:Own",
  DELETE_USER_OWN: "Delete:User:Own",
  VIEW_SALES_OWN: "View:Sales:Own",
  CREATE_SALES_OWN: "Create:Sales:Own",
  UPDATE_SALES_OWN: "Update:Sales:Own",
  DELETE_SALES_OWN: "Delete:Sales:Own",
  RESETPASSWORD_USER_OWN: "ResetPassword:User:Own",
  CREATE_WAREHOUSE_OWN: "Create:Warehouse:Own",
  UPDATE_WAREHOUSE_OWN: "Update:Warehouse:Own",
  DELETE_WAREHOUSE_OWN: "Delete:Warehouse:Own",
  VIEW_SHIPPINGPROVIDER_OWN: "View:ShippingProvider:Own",
  VIEW_MANUFACTURER_OWN: "View:Manufacturer:Own",
  VIEW_BATCH_OWN: "View:Batch:Own",
  CREATE_BATCH_OWN: "Create:Batch:Own",
  UPDATE_BATCH_OWN: "Update:Batch:Own",
  DELETE_BATCH_OWN: "Delete:Batch:Own",
  SCANITEM_BATCH_OWN: "ScanItem:Batch:Own",
  VIEW_INVENTORY_OWN: "View:Inventory:Own",
  UPDATE_INVENTORY_OWN: "Update:Inventory:Own",
  VIEW_ORDER_OWN: "View:Order:Own",
  CREATE_ORDER_OWN: "Create:Order:Own",
  UPDATE_ORDER_OWN: "Update:Order:Own",
  DELETE_ORDER_OWN: "Delete:Order:Own",
  CHANGESTATUS_ORDER_OWN: "ChangeStatus:Order:Own",
  PREPARE_ORDER_OWN: "Prepare:Order:Own",
  PROCESSRETURNORDER_ORDER_OWN: "ProcessReturnOrder:Order:Own",
  VIEW_WAREHOUSETRANSFEREXPORT_OWN: "View:WarehouseTransferExport:Own",
  CREATE_WAREHOUSETRANSFEREXPORT_OWN: "Create:WarehouseTransferExport:Own",
  UPDATE_WAREHOUSETRANSFEREXPORT_OWN: "Update:WarehouseTransferExport:Own",
  PREPARE_WAREHOUSETRANSFEREXPORT_OWN: "Prepare:WarehouseTransferExport:Own",
  DELETE_WAREHOUSETRANSFEREXPORT_OWN: "Delete:WarehouseTransferExport:Own",
  REVIEW_WAREHOUSETRANSFEREXPORT_OWN: "Review:WarehouseTransferExport:Own",
  CHANGESTATUS_WAREHOUSETRANSFEREXPORT_OWN: "ChangeStatus:WarehouseTransferExport:Own",
  VIEW_WAREHOUSETRANSFERIMPORT_OWN: "View:WarehouseTransferImport:Own",
  CREATE_WAREHOUSETRANSFERIMPORT_OWN: "Create:WarehouseTransferImport:Own",
  UPDATE_WAREHOUSETRANSFERIMPORT_OWN: "Update:WarehouseTransferImport:Own",
  PREPARE_WAREHOUSETRANSFERIMPORT_OWN: "Prepare:WarehouseTransferImport:Own",
  DELETE_WAREHOUSETRANSFERIMPORT_OWN: "Delete:WarehouseTransferImport:Own",
  CHANGESTATUS_WAREHOUSETRANSFERIMPORT_OWN: "ChangeStatus:WarehouseTransferImport:Own",
  VIEW_INVENTORYNOTE_OWN: "View:InventoryNote:Own",
  CREATE_INVENTORYNOTE_OWN: "Create:InventoryNote:Own",
  VIEW_SYSTEM_OWN: "View:System:Own",
};

export const PERMISSION_VALUES = [
  "View:User:All",
  "Create:User:All",
  "Update:User:All",
  "Delete:User:All",
  "View:Sales",
  "Create:Sales:All",
  "Update:Sales:All",
  "Delete:Sales:All",
  "ResetPassword:User:All",
  "ResetPassword:Sales",
  "View:Role",
  "Create:Role",
  "Update:Role",
  "Delete:Role",
  "View:Warehouse:All",
  "Create:Warehouse:All",
  "Create:Warehouse:Own",
  "Update:Warehouse:All",
  "Update:Warehouse:Own",
  "Delete:Warehouse:All",
  "Delete:Warehouse:Own",

  "View:ShippingProvider:All",
  "Create:ShippingProvider",
  "Update:ShippingProvider",
  "Delete:ShippingProvider",
  "View:Manufacturer:All",
  "Create:Manufacturer",
  "Update:Manufacturer",
  "Delete:Manufacturer",
  "View:Brand",
  "Create:Brand",
  "Update:Brand",
  "Delete:Brand",
  "View:ProductGroup",
  "View:Product",
  "Create:Product",
  "Update:Product",
  "Delete:Product",
  "View:Batch:All",
  "Create:Batch:All",
  "Update:Batch:All",
  "Delete:Batch:All",
  "ScanItem:Batch:All",
  "View:Inventory:All",
  "Update:Inventory:All",
  "View:Customer",
  "Create:Customer",
  "Update:Customer",
  "Delete:Customer",
  "Custom:Customer",
  "View:Order:All",
  "Create:Order:All",
  "Update:Order:All",
  "Delete:Order:All",
  "ChangeStatus:Order:All",
  "Prepare:Order:All",
  "ProcessReturnOrder:Order:All",
  "View:WarehouseTransferExport:All",
  "Create:WarehouseTransferExport:All",
  "Update:WarehouseTransferExport:All",
  "Prepare:WarehouseTransferExport:All",
  "Delete:WarehouseTransferExport:All",
  "Review:WarehouseTransferExport:All",
  "ChangeStatus:WarehouseTransferExport:All",
  "View:WarehouseTransferImport:All",
  "Create:WarehouseTransferImport:All",
  "Update:WarehouseTransferImport:All",
  "Prepare:WarehouseTransferImport:All",
  "Delete:WarehouseTransferImport:All",
  "ChangeStatus:WarehouseTransferImport:All",
  "View:InventoryNote:All",
  "Create:InventoryNote:All",
  "View:Provider",
  "Create:Provider",
  "Update:Provider",
  "Delete:Provider",
  "View:BankInfo",
  "Create:BankInfo",
  "Update:BankInfo",
  "Delete:BankInfo",
  "View:System:All",
  "View:User:Own",
  "Create:User:Own",
  "Update:User:Own",
  "Delete:User:Own",
  "View:Sales:Own",
  "Create:Sales:Own",
  "Update:Sales:Own",
  "Delete:Sales:Own",
  "ResetPassword:User:Own",
  "Create:Warehouse:Own",
  "Update:Warehouse:Own",
  "Delete:Warehouse:Own",
  "View:ShippingProvider:Own",
  "View:Manufacturer:Own",
  "View:Batch:Own",
  "Create:Batch:Own",
  "Update:Batch:Own",
  "Delete:Batch:Own",
  "ScanItem:Batch:Own",
  "View:Inventory:Own",
  "Update:Inventory:Own",
  "View:Order:Own",
  "Create:Order:Own",
  "Update:Order:Own",
  "Delete:Order:Own",
  "ChangeStatus:Order:Own",
  "Prepare:Order:Own",
  "ProcessReturnOrder:Order:Own",
  "View:WarehouseTransferExport:Own",
  "Create:WarehouseTransferExport:Own",
  "Update:WarehouseTransferExport:Own",
  "Prepare:WarehouseTransferExport:Own",
  "Delete:WarehouseTransferExport:Own",
  "Review:WarehouseTransferExport:Own",
  "ChangeStatus:WarehouseTransferExport:Own",
  "View:WarehouseTransferImport:Own",
  "Create:WarehouseTransferImport:Own",
  "Update:WarehouseTransferImport:Own",
  "Prepare:WarehouseTransferImport:Own",
  "Delete:WarehouseTransferImport:Own",
  "ChangeStatus:WarehouseTransferImport:Own",
  "View:InventoryNote:Own",
  "Create:InventoryNote:Own",
  "View:System:Own",
];

export const roleCheck = (permissions = [], userMe) => {
  if (!Array.isArray(permissions) || !permissions.length) return false;

  const rolePermissionKeys = userMe?.role?.rolePermissions?.map((permission) => permission?.key ?? permission) ?? [];

  return permissions.some((permission) => rolePermissionKeys.includes(permission));
};

export const useRoleCheck = () => {
  const { userMe } = useAuthGlobal();

  return (permissions = []) => roleCheck(permissions, userMe);
};
